<template>
  <a-card :bordered='false' v-if='checkResult'>
    <SignFileShow v-if="xstatus.isCheckOpenTable === '1' && !pdfCententShow" :sectionId='sectionId'
                  :type='pdfParams.type'></SignFileShow>
    <div style='margin-bottom:10px;display: inline-block' v-if="xstatus.isCheckOpenTable !== '1'">
      <a-space>
        <a-button v-if="xstatus.isCheckOpenTable !== '1' && !pdfCententShow" type='primary' @click='startCheck()'>发起确认</a-button>
        <a-button v-if="xstatus.isCheckOpenTable !== '1' && pdfCententShow" htmlType='button'
                  @click='saveSignFile' :loading='loading' type='primary'>保存签章文件
        </a-button>
        <SignatureButton
          v-show='!pdfCententShow'
          ref='SignatureButton'
          :pdf-params='pdfParams'
          :stampShowed='pdfCententShow'
          :disabled="xstatus.isCheckOpenTable === '1'"
          @sign='sign'
          @signShow='signShow'
        ></SignatureButton>
      </a-space>
    </div>
    <!-- table区域-begin -->
    <div v-show='!pdfCententShow' id='pdfCentent' v-if="xstatus.isCheckOpenTable !== '1'">
      <div v-if='htmlStr != ""' v-html='htmlStr'>

      </div>
      <div v-if='htmlStr == ""'>
        <a-table
          ref='table'
          bordered
          size='middle'
          :columns='columns'
          :dataSource='dataSource'
          :loading='loading'
          :pagination='false'>
          <template slot='title' slot-scope='currentPageData'>
            <a-row>
              <a-col :span='24' style='width: 100%;text-align: center;font-size: 24px;'>
                <div>第一个信封（商务及技术文件)开标记录表</div>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span='12' style='text-align: left;'>
                <span>标段编号：{{ sectionInfo.bidSectionCode }}</span>
              </a-col>
              <a-col :span='12' style='text-align: right;'>
                <span>开标时间：{{ openHomeBeginTime }}</span>
              </a-col>
            </a-row>
          </template>
        </a-table>
        <div style='margin-top: 20px'>
          <div style='width: 33%;font-size: 15px;display: inline-block'>招标人代表：_____________________</div>
          <div style='width: 33%;font-size: 15px;display: inline-block;text-align: center'>
            招标代理：_____________________
          </div>
          <div style='width: 33%;font-size: 15px;display: inline-block;text-align: right'>监标人：_____________________
          </div>
        </div>
      </div>
    </div>
    <SignatureComponent
      v-show='pdfCententShow'
      ref='stamp'
      :pdf-params='pdfParams'
      @checkStampForm='checkStampForm'
      @changeIsStamp='changeIsStamp'
    ></SignatureComponent>
    <SignFileShow-modal ref='modalForm'></SignFileShow-modal>
    <a-modal v-model='visible' title='确认时长' @ok="checkTimer">
      <a-row :gutter='[0,24]'>
        <a-col :span='24'>
          投标人确认时长(分钟)：
          <a-input-number v-model='time' :min="1" :max="100" :step="1" :precision="0"/>
        </a-col>
      </a-row>
    </a-modal>
  </a-card>
</template>

<script>

import { FzisListMixin } from '@/mixins/FzisListMixin'
import { StatusMixin } from '@/mixins/StatusMixin'
import { getAction, postAction } from '@api/manage'
import numeral from 'numeral'
import SignFileShowModal from '@views/bobidopen/modules/SignFileShowModal'
import SignFileShow from '@views/bobidopen/modules/SignFileShow'
import stamp from '@/components/Stamp'
import WorkChangeStamp from '@/components/WorkChangeStamp'
import SignatureComponent from '@/components/SignatureComponent'
import SignatureButton from '@/components/SignatureButton'

export default {
  name: 'SpeedSupervisorFirstOpenTable',
  mixins: [FzisListMixin, StatusMixin],
  components: { WorkChangeStamp, stamp ,SignatureComponent,SignatureButton, SignFileShowModal, SignFileShow,},
  data() {
    return {
      description: '第一信封开标情况记录表',
      htmlStr:"",
      boBidderRepeat: {},
      columns: [
        {
          title: '序号',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: function(t, r, index) {
            return parseInt(index) + 1
          }
        },
        {
          title: '投标人名称',
          align: 'left',
          dataIndex: 'bidderName'
        },
        {
          title: '投标人编号',
          align: 'left',
          width: 100,
          dataIndex: 'bidderNumber'
        },
        {
          title: '投标时间',
          align: 'left',
          width: 200,
          dataIndex: 'tenderDocSubmittime'
        },
        {
          title: '企业信用等级',
          align: 'left',
          width: 100,
          dataIndex: 'enterpriseCreditGrade'
        },
        {
          title: '总监理工程师',
          children: [
            {
              title: '姓名',
              dataIndex: 'bidManager',
              align: 'left',
              width: 200
            },
            {
              title: '信用等级',
              dataIndex: 'managerCreditGrade',
              align: 'left',
              width: 50
            }
          ]
        },
        {
          title: '保证金递交情况',
          align: 'left',
          width: 100,
          dataIndex: 'depositStatus',
          customRender: function(t, r, index) {
            return t == "1" ? "已递交" : "未递交";
          }
        },
        {
          title: '投标人代表确认',
          align: 'left',
          width: 100,
          dataIndex: 'isChecked',
          customRender: function(t, r, index) {
            if (t == "1") {
              return "已确认"
            }
            if (t == "0") {
              return "未确认"
            }
            if (t == "-1") {
              return "已提交异议"
            }
            if (t == "-2") {
              return "已超时自动确认"
            }
          }
        }
      ],
      url: {
        list: ''
      },
      sectionId: '',
      bidProjectId: '',
      disableMixinCreated: true,
      tenderProjectInfo: {},
      sectionInfo: {},
      openInfo: {},
      sectionInfos: [],
      openHomeBeginTime: '',
      visible: false,
      time: null,
      //以下签章-----------
      isNeedStamp: true,
      isStamp: true,
      pdfCententShow: false,
      htmlParams: {
        bidProjectId: '',
        sectionId: '',
        type: 'FirstOpenTable',
        typeZh: '开标记录表一',
        htmlTitle: '开标记录表一',
        fp: '2',
      },
      pdfParams: {
        pageId: '',
        signedPdfUrl: '',
        bidProjectId: '',
        sectionId: '',
        type: 'FirstOpenTableStamp',
        typeZh: '开标记录表一签章',
        htmlTitle: '开标记录表一签章',
        fp: '4',
        signType: '1'//1:统一CA，2：工改签章
      },
      signDisabled: false
    }
  },
  props: ['checkId'],
  created() {
  },
  methods: {
    setBidProjectId(tenderId, sectionId) {
      //1.根据招标编号ID获取招标项目信息和项目信息
      this.bidProjectId = tenderId
      this.pdfParams.bidProjectId = tenderId
      this.pdfParams.sectionId = sectionId
      this.sectionId = sectionId
      this.queryParam.sectionId = sectionId
      this.url.list = '/ebid-ce/tmBidder/querySpeedFirstBidder/' + sectionId + '/' + this.checkId
      this.loadData()
      this.getTenderInfo()
      this.queryStatus()
      //this.getBoOpenConfig()
      this.htmlParams.bidProjectId = tenderId
      this.htmlParams.sectionId = sectionId
      //设置本页面标识，用于redis key记录当前页面签章信息
      this.pdfParams.pageId = this.sectionId + '_FirstOpenTable_' + new Date().getTime()
      this.getOpenTime()

    },
    getOpenTime() {
      getAction('/room/schedule/getListByTmRoomSchedule', {
        bidProjectId: this.bidProjectId,
        roomType: '1'
      }).then(res => {
        if (res.success) {
          this.openHomeBeginTime = res.result[0].beginTime
        } else {
          this.$message.warning('开标时间获取失败')
        }
      })
    },
    startCheck() {
      for(let i in this.dataSource)
      {
        this.dataSource[i].isChecked="0";
      }
      this.visible = true;
      this.$nextTick(() => {
        this.pdfCententShow = true
        this.$refs.stamp.viewStamp()
      });
    },
    checkTimer() {
      let that = this;
      if(that.pdfParams.signedPdfUrl==null)
      {
        that.$message.error('请等待页面加载完再进行操作！')
        return;
      }
      this.$confirm({
        title: '提示',
        content: '是否立即发送投标人确认？',
        onOk() {
          let params = {}
          params.sectionId = that.sectionId
          params.pdfUrl = that.pdfParams.signedPdfUrl
          params.timeDuration = that.time
          params.menuId = that.checkId
          postAction('/ebid-ce/tmBidderCheck/add', params).then(res => {
            if (res.success) {
              that.visible = false;
              that.$message.success("等待投标企业确认内容");
            } else {
              that.$message.error(res.message)
            }
          }).catch(() => {
            that.$message.error('操作失败，请重试！')
          }).finally(() => {
            that.loading = false
          })
            }
      });
    },
    getTenderInfo() {
      getAction('/ebid-ce/tmBidSection/queryById', { id: this.$route.query.sectionId }).then(res => {
        if (res.success) {
          this.tenderProjectInfo = res.result.tmBidProject;
          this.sectionInfo = res.result;
        } else {
          this.$message.error(res.message)
        }
      }).catch(() => {
        this.$message.error('操作失败，请重试！')
      })

      //3、开标安排信息
      getAction("/ebid-ce/tmSecTender/queryOpenRoomByBidId/"+ this.$route.query.id, {}).then(res => {
        if (res.success) {
          this.openInfo = res.result;
        }
      });
    },
    //-----------以下为签章--------------------
    sign(type) {
      this.pdfParams.signType = type
      this.pdfCententShow = true
      this.$refs.stamp.checkStamp()
    },
    //签章文件查看
    signShow() {
      this.$refs.modalForm.show(this.sectionId, this.pdfParams.type)
    },
    //重新编辑
    reEdit() {
      this.pdfParams.pageId = ''
      this.pdfParams.signedPdfUrl = ''
      this.pdfCententShow = false
      this.$refs.stamp.pdfUrl = null
    },
    changeIsStamp(val) {
      this.pdfCententShow = val
    },
    checkStampForm(callback) {
      callback(true)
    },
    saveSignFile() {
      let that = this
      if (this.$refs.stamp.getPdfUrl() == null) {
        this.$message.info('请先获取签章文件后再进行保存提交！')
        return
      }
      let params = {}
      params.pdfUrl = that.$refs.stamp.getPdfUrl()
      params.type = that.pdfParams.type
      params.typeZh = that.pdfParams.typeZh
      params.bidProjectId = that.pdfParams.bidProjectId
      params.checkId = that.checkId
      params.key = "isCheckOpenTable"
      postAction('/ebid-ce/boOpenStatus/saveOpenStatusSignFile/' + that.sectionId, params).then(res => {
        if (res.success) {
          that.xstatus.isCheckOpenTable = '1'
        } else {
          that.$message.error(res.message)
        }
      }).catch(() => {
        that.$message.error('操作失败，请重试！')
      }).finally(() => {
        that.loading = false
      })
    },
  }
}
</script>

<style scoped>

</style>